import styled from 'styled-components';
import { Container } from '../../../common/input-search-with-sidebar/input-search-with-sidebar.styles';
import {
  ClearSearchButton,
  SearchIconContainer,
} from '../../../common/input-search/input-search.styles';
import { FontSizes } from '../../../common/typography/typography.styles';

export const GatewayCategorySearchSidebarContainer = styled(Container)`
  .category-search-header {
    min-width: 0;
  }

  .category-search-field {
    position: relative;

    input {
      height: 4.8rem;
      max-height: 4.8rem;
      border-color: ${({ theme }) => theme.colors.baseColors.grey25};
      font-size: ${FontSizes.normal};

      &::placeholder {
        font-size: ${FontSizes.normal};
      }
    }

    ${SearchIconContainer} {
      top: 50%;
      bottom: auto;

      svg path {
        fill: ${({ theme }) => theme.colors.baseColors.grey100};
      }
    }

    &.with-ai-actions {
      input {
        padding-right: 4.4rem;
      }

      &:has(${ClearSearchButton}, .spinnerContainer) input {
        padding-right: 7.2rem;
      }

      ${ClearSearchButton},
      .spinnerContainer {
        right: 4.8rem;
      }
    }

    &.with-voice-action {
      input {
        padding-right: 7.6rem;
      }

      &:has(${ClearSearchButton}, .spinnerContainer) input {
        padding-right: 10.4rem;
      }

      ${ClearSearchButton},
      .spinnerContainer {
        right: 8rem;
      }
    }
  }
`;

export const MaterialCategoryIcon = styled.span.attrs({
  'aria-hidden': true,
  className: 'material-symbols-outlined',
})`
  width: 1em;
  height: 1em;
  color: inherit;
  font-family: 'Material Symbols Outlined' !important;
  font-size: 2rem;
  line-height: 1;
`;
